
import DrawBase from "./DrawBase"
import EditPoint from "./EditPoint"
class DrawPoint extends DrawBase {
    constructor(options) {
        super(options);
        this._style=undefined;
    }

    get style(){
        return this._style;
    }

    set style(val){
        this._style=val;
    }

    leftDoubleClick() {

    }
    //左键
    leftClick(evt) {
        console.log(this.style);
        var position = this.getCatesian3FromPX(evt.position);
        this.plot = this.createPoint(position);
        this.initEditor();
        this.entities.push(this.plot);
        this.callback && this.callback(this.plot,this.style);
        this.destroy();
        this.startEdit();
    }

    initEditor() {
        //初始化编辑器
        this.editHelp = new EditPoint(this.options); //初始化编辑类
    }
}

export default DrawPoint;